import React from "react";
import UploadExcelModal from "./UploadMasterExcel";
import ModalAdd from "./ModalAdd";
import {
  Download,
  FileDown,
  FileUp,
  Plus,
  Trash2,
  Upload,
  X,
} from "lucide-react";

const FloatingFab = ({
  showFabOptions,
  setShowFabOptions,
  handleShow,
  setShowModel,
  user,
  dataHandle,
  commonData,
  downloadColumnFile,
}) => {
  return (
    <div className="fab-container">
      <div className="fab-options-wrapper d-flex flex-column align-items-end gap-2">
        <div className={`fab-options ${showFabOptions ? "show" : ""}`}>
          {user?.role === "admin" && commonData?.length >= 0 && (
            <div className="position-relative">
              <button
                type="button"
                className="btn btn-primary btn-sm rounded-circle"
                style={{ padding: "6px" }}
                onClick={() => setShowModel(true)}
              >
                <Trash2 />
              </button>
              <span className="fab-label">Delete Master</span>
            </div>
          )}

          {/* Admin-only buttons */}
          {user?.role === "admin" && (
            <>
              <div className="position-relative">
                <ModalAdd className="px-1 py-1" dataHandle={dataHandle} />
                <span className="fab-label">Add Master</span>
              </div>
            </>
          )}

          {commonData?.length > 0 && (
            <>
              <div className="position-relative">
                <button
                  className="btn btn-primary btn-sm rounded-circle "
                  style={{ padding: "6px" }}
                  onClick={handleShow}
                >
                  <Download />
                </button>
                <span className="fab-label">Download Excel</span>
              </div>

              <div className="position-relative">
                <UploadExcelModal
                  uploadType="data"
                  modalTitle="Upload Excel File"
                  asFloatingButton
                  icons={<Upload />}
                />
                <span className="fab-label">Upload Excel</span>
              </div>

              <div className="position-relative ">
                <UploadExcelModal
                  uploadType="column"
                  asFloatingButton
                  modalTitle="Upload Column Visibility File"
                  icons={<FileUp />}
                />
                <span className="fab-label">
                  Upload Column Visibility Excel
                </span>
              </div>

              <div className="position-relative mb-2">
                <button
                  className="btn btn-primary btn-sm rounded-circle "
                  style={{ padding: "6px" }}
                  onClick={downloadColumnFile}
                >
                  <FileDown />
                </button>

                <span className="fab-label">
                  Download file for Column Visibility Excel
                </span>
              </div>
            </>
          )}
        </div>

        {/* Main FAB toggle button */}
        <button
          className={`btn btn-fab custom-fab-button shadow ${
            showFabOptions ? "btn-open" : "btn-close"
          }`}
          onClick={() => setShowFabOptions(!showFabOptions)}
          aria-label={showFabOptions ? "Close menu" : "Open menu"}
        >
          {showFabOptions ? <X /> : <Plus />}
        </button>
      </div>
    </div>
  );
};

export default React.memo(FloatingFab);
